// Where a logged-in user lands after login (and on any unknown URL).
//
// The built-in roles keep their fixed landing pages. Any other role (e.g. one
// created later) lands on Home if it's assigned, otherwise on the first module
// it can open, so a new role never lands on a page it has no access to.

export const HOME_PATH = "/swiftboard/home";

const ROLE_LANDING_PATHS = {
  SUPER_ADMIN: HOME_PATH,
  CLIENT:      HOME_PATH,
  ADMIN:       "/swiftboard/live-projects",
  EMPLOYEE:    "/swiftboard/live-projects",
};

export const getLandingPath = (user, allowedPaths = []) => {
  const rolePath = ROLE_LANDING_PATHS[user?.user_role?.role];
  if (rolePath) return rolePath;
  if (allowedPaths.includes(HOME_PATH)) return HOME_PATH;
  // Parent modules carry "#" as their path; skip them
  return allowedPaths.find((path) => path && path !== "#") || HOME_PATH;
};
